import { render } from "./MintCard.vue?vue&type=template&id=9161cde4&scoped=true"
import script from "./MintCard.vue?vue&type=script&lang=js"
export * from "./MintCard.vue?vue&type=script&lang=js"

import "./MintCard.vue?vue&type=style&index=0&id=9161cde4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9161cde4"]])

export default __exports__